<template>
	<vue-final-modal
		v-slot="{ params, close }"
		v-bind="$attrs"
		:classes="{
			'app-modal': true,
			'app-modal_loading': sleep
		}"
		content-class="app-modal__content"
		@opened="opened"
		:esc-to-close="true"
		:focus-trap="true"
		:content-style="{width: maxWidth+'px'}"
	>
		<span class="app-modal__title">
			<slot name="title"></slot>
		</span>

		<div class="app-modal__body">
			<slot :params="params"></slot>
		</div>
<!--		<div class="app-modal__action">-->
<!--			<button type="button" @click="$emit('confirm', close)">confirm</button>-->
<!--			<button type="button" @click="$emit('cancel', close)">cancel</button>-->
<!--		</div>-->
		<button type="button" class="btn app-modal__close" @click="close">
			<svg width="16" height="16" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
				<path fill="currentColor" d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"/>
			</svg>
		</button>
	</vue-final-modal>
</template>
<script>
export default {
	name: 'app-modal',
	inheritAttrs: false,
	emits: ['confirm', 'cancel'],
	props: {
		sleep: {
			type: Boolean,
			default() {
				return false;
			}
		},
		maxWidth: {
			type: Number,
			default() {
				return 600
			}
		}
	},
	data() {
		return {
			opened(e) {
				const element = e.ref.vfmContent.value;
				const autofocusControl = element.querySelector('[data-autofocus]');

				autofocusControl && autofocusControl.focus();
			}
		}
	}
}
</script>
<style lang="sass">
.app-modal
	display: flex
	justify-content: center
	align-items: center

	&_loading
		.app-modal__content
			&::before
				position: absolute
				top: 0
				left: 0
				right: 0
				bottom: 0
				background-color: rgba(white, 0.8)
				border-radius: $border-radius
				content: ''

			&::after
				position: absolute
				top: 0
				left: 0
				right: 0
				bottom: 0
				width: 50px
				height: 50px
				margin: auto
				border: 1px solid transparent
				border-top-color: $primary
				animation: app-modal-spinner 0.5s linear infinite
				border-radius: 50%
				content: ''

	&__content
		position: relative
		display: flex
		flex-direction: column
		width: 100%
		max-height: 90%
		margin: 0 1rem
		padding: 2rem
		outline: 4px solid rgba($dark, 0.05)
		border-radius: $border-radius
		color: $dark
		background: white
		overflow: auto

	&__title
		margin: 0 2rem 2rem 0
		font: 600 2rem $font-primary

		&:empty
			display: none

	&__body
		flex-grow: 1

	&__action
		display: flex
		justify-content: center
		align-items: center
		flex-shrink: 0
		padding: 1rem 0 0

	&__close
		position: absolute
		top: 0.5rem
		right: 0.5rem
		box-shadow: none

		&:hover,
		&:focus
			color: $danger

@keyframes app-modal-spinner
	to
		transform: rotate(360deg)

@media screen and (max-width: map-get($grid-breakpoints, md) - 1)
	.app-modal
		align-items: flex-start

		&__title
			line-height: 1

		&__content
			margin: 4px
			padding: $container-padding-x
			max-height: calc(100% - 8px)
</style>